var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import notificationSocketConnection from "../sockets/notification.socket";
import { getDataFromStorage } from "../libs/auth.helper";
import useConfig from "../hooks/use-config";
let notificationSocket = null;
const SocketContext = React.createContext({
    socket: null,
    initialNotification: () => {
    },
    isConnectionFailed: false
});
export const SocketContextProvider = (props) => {
    const config = useConfig();
    const [socket, setSocket] = useState(null);
    const [isConnectionFailed, setIsConnectionFailed] = useState(false);
    console.log("V2.3.2");
    console.log(config);
    const getToken = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield config.getToken();
    });
    const fireAuthentication = () => new Promise((resolve) => getToken().then((token) => {
        const authData = {
            user_id: parseInt(getDataFromStorage().userInfo.id || ''),
            token: token,
            platform: getDataFromStorage().audience,
            country: getDataFromStorage().country,
            lang: config.lang,
        };
        notificationSocket.emit('authentication', authData, function (...data) {
            console.log(data, 'res');
            resolve(true);
            setIsConnectionFailed(false);
        });
    }));
    const initialNotification = () => {
        return new Promise((resolve) => getToken().then((token) => {
            notificationSocket = notificationSocketConnection(config.urls.gulpin2);
            notificationSocket.on("connect", function () {
                if (socket)
                    return;
                fireAuthentication().then(() => {
                    console.log('reconnect auth');
                    setSocket(notificationSocket);
                }).catch((err) => {
                    console.log('AUTH ERROR', err);
                });
            });
            notificationSocket.on("rt-event", function (response) {
                var _a, _b;
                if ((response === null || response === void 0 ? void 0 : response.name) === 'continue_draft' && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.country) == ((_b = getDataFromStorage()) === null || _b === void 0 ? void 0 : _b.country))
                    config.RTHandler(response);
            });
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.on('disconnect', function (err) {
                setSocket(null);
            });
            notificationSocket.on('error', function (err) {
                setSocket(null);
                setIsConnectionFailed(true);
            });
            notificationSocket.on("connect_error", function () {
                setSocket(null);
            });
        }));
    };
    useEffect(() => {
        if (socket)
            return;
        if (notificationSocket && notificationSocket.connected)
            notificationSocket.disconnect();
        notificationSocket = null;
        initialNotification().then((socket) => {
            setSocket(socket);
        });
        return () => {
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.off('connect');
            notificationSocket === null || notificationSocket === void 0 ? void 0 : notificationSocket.off('disconnect');
            socket === null || socket === void 0 ? void 0 : socket.disconnect();
        };
    }, [socket]);
    useEffect(() => {
        if (!socket)
            return;
        return () => {
            console.log('clean up socket');
            socket === null || socket === void 0 ? void 0 : socket.off('connect');
            socket === null || socket === void 0 ? void 0 : socket.off('disconnect');
        };
    }, [socket]);
    return (React.createElement(SocketContext.Provider, { value: {
            socket,
            initialNotification,
            isConnectionFailed
        } }, props.children));
};
export default SocketContext;
